import React, { FC } from 'react'

import { IconEditProps } from './IconEdit.types'
import * as Styled from './styles/IconEdit.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEdit: FC<IconEditProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEditProps['size'],
  isResponsive = false,
}: IconEditProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='m36.845 17.527-6.453-6.522' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='m42 12.373-4.5-4.555a2.75 2.75 0 0 0-3.908 0L30.392 11 9.122 32.275 6.942 41l8.725-2.182L42 12.373Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='m9.887 31.525 6.546 6.545' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconEdit
